import AkkaLink from '@commons/AkkaLink/AkkaLink';
import './_button.scss';

function ButtonIcon({ children = null, icon = undefined }) {
  if (icon) {
    return <span className="Button__Icon">{icon}</span>;
  }
  return <span className="Button__Icon">{children}</span>;
}

export default function Button({
  children,
  href = undefined,
  onClick = undefined,
  priority = 'primary', // 'primary' | 'secondary'
  size = 'l', // 's' | 'm' | 'l' | 'auto'
  disabled = false,
  className = '',
  ...props
}) {
  const classes = ['Button', `Button--priority-${priority}`, `Button--size-${size}`, className]
    .filter(Boolean)
    .join(' ');

  const Component = href ? AkkaLink : 'button';

  return (
    <Component href={href} className={classes} onClick={onClick} disabled={disabled} {...props}>
      {children}
    </Component>
  );
}

Button.Icon = ButtonIcon;
